import React, { FC } from 'react'
import s from './MagePlazaProductBadge.module.scss'
import cn from 'classnames'

type labelProps = {
    priority: number
    label_template: string
    label_image: string
    label_position: string
    same: boolean
    list_template: string
    list_image: string
    list_position: string
}

type Props = {
    labelData: Array<labelProps>
    showAll?: boolean
    showAllCustom?: boolean
    isPDP?: boolean
}

export const sortLabelData = (a: labelProps, b: labelProps): number => {
    if (!a?.priority || !b?.priority) {
        return 0
    }
    return a.priority - b.priority
}

export const listTemplate = (data: labelProps) => {
    return data.list_image ? data.list_image : data.list_template
}

export const detailTemplate = (data: labelProps) => {
    return data.label_image ? data.label_image : data.label_template
}

export const MagePlazaProductBadge: FC<Props> = ({
    labelData,
    showAll = false,
    showAllCustom = false,
    isPDP = false
}) => {
    if (labelData.length == 0) return null

    labelData.sort(sortLabelData)

    const displayAllBadges = () => {
        return (
            <>
                {labelData.map((data: labelProps, index: number) => {
                    return (
                        <div
                            id={`design-labels-${index}`}
                            className={cn(
                                s['mpproduct-badge'],
                                showAllCustom
                                    ? `mpproduct-badge-custom-${index}`
                                    : `mpproduct-badge`
                            )}
                            key={`badge${index}`}
                            style={
                                showAll
                                    ? {
                                          ...JSON.parse(data.list_position)
                                              .label
                                      }
                                    : {}
                            }
                        >
                            <img
                                className={s['mpproduct-badge-img']}
                                src={
                                    data.same || (!data.same && !isPDP)
                                        ? listTemplate(data)
                                        : detailTemplate(data)
                                }
                                alt=""
                            />
                        </div>
                    )
                })}
            </>
        )
    }

    const displayPriorityBadge = () => {
        const priorityLabel = labelData[0]
        return (
            <div
                id="design-badge"
                className={cn(s['mpproduct-badge'], 'mpproduct-badge-priority')}
                key={`badge${priorityLabel.priority}`}
            >
                <img
                    className={s['mpproduct-badge-img']}
                    src={
                        priorityLabel.same || (!priorityLabel.same && !isPDP)
                            ? listTemplate(priorityLabel)
                            : detailTemplate(priorityLabel)
                    }
                    alt=""
                />
            </div>
        )
    }

    return showAll || showAllCustom
        ? displayAllBadges()
        : displayPriorityBadge()
}
